import { Component, Input, OnInit } from '@angular/core';

import { UaService } from '@ecm/consumer';
import { RouterService } from '@ecm/router';

import { UniverseEnum } from '../../../../business/api/dashboard/universeEnum';
import { TerminatedContractViewModel } from '../../../../business/model/crossroads/contracts-options/terminated-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { AbstractComponent } from '../../../shared/abstract.component';

@Component({
    selector: 'terminated-contract',
    templateUrl: 'terminated-contract.html',
    styleUrls: ['terminated-contract.css'],
    standalone: true,
})
export class TerminatedContractComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: ContractsViewModel;

    @Input()
    public borderBottom = true;

    @Input()
    public universe: UniverseEnum;

    public terminatedContractViewModel: TerminatedContractViewModel;

    public mixedSoshPicto = 'assets/dashboard/images/mini-logo-sosh.svg';
    public mixedOrangePicto = 'assets/dashboard/images/mini-logo-orange.png';

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
    ) {
        super(uaService, routerService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.viewModel.contract) {
            this.terminatedContractViewModel = this.viewModel.contract as TerminatedContractViewModel;
        }
    }

    /**
     * get Sosh or Orange icon
     * @return {string}
     */
    public getIcon(): string {
        let icon: string = null;
        if (this.universe === UniverseEnum.MIXED && this.terminatedContractViewModel.picto) {
            if (
                this.viewModel.brand.toUpperCase() === UniverseEnum.SOSH &&
                this.terminatedContractViewModel.picto.toUpperCase() === UniverseEnum.ORANGE
            ) {
                icon = this.mixedSoshPicto;
            } else if (
                this.viewModel.brand.toUpperCase() === UniverseEnum.ORANGE &&
                this.terminatedContractViewModel.picto.toUpperCase() === UniverseEnum.ORANGE
            ) {
                icon = this.mixedOrangePicto;
            }
        }
        return icon;
    }
}
